import http from '../../HttpConfig'
import {APIS_ENDPOINTS} from '../../SERVICE-CONSTANTS'

const setting_endpoints = APIS_ENDPOINTS.setting

export const request_getsettings = async () => {
  return http.get(setting_endpoints.getsettings)
}

export interface SettingsData {
  Title: string
  Description: string
  Address: string
  PhoneNumber: string
  Email: string
  Instagram: string
  Lat: string
  Lng: string
  SplashLogo: File | null
  ShortcutIcon: File | null
  YouTube: string
  Aparat: string
  Telegram: string
  Whatsapp: string
  Schemas: string
  Tel: string
  Linkdin: string
  AboutPageImage: File | null
  AboutPageTitle: string
  AboutPageText: string
  Color1: string
  Color2: string
  Color3: string
  Color4: string
  Font: File | null
}

export const request_upsertsettings = async (settingsData: SettingsData) => {
  const formData = new FormData()

  // Append all string fields
  Object.entries(settingsData).forEach(([key, value]) => {
    if (value !== null && !(value instanceof File)) {
      formData.append(key, value)
    }
  })

  // Append file fields
  if (settingsData.SplashLogo) formData.append('SplashLogo', settingsData.SplashLogo)
  if (settingsData.ShortcutIcon) formData.append('ShortcutIcon', settingsData.ShortcutIcon)
  if (settingsData.AboutPageImage) formData.append('AboutPageImage', settingsData.AboutPageImage)
  if (settingsData.Font) formData.append('Font', settingsData.Font)
  return http.put(setting_endpoints.upsertsettings, formData)
}


export const downloaderFile = async ({
  fileUrl,
  fileName,
}: {
  fileUrl: string
  fileName: string
}) => {
  return http.get(setting_endpoints.downloaderFile + '?fileUrl=' + fileUrl + '&fileName=' + fileName, {
    responseType: 'blob'
  })
}